var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconWaypointFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9 18s7-7 7-11.543C16 2.89 12.866 0 9 0S2 2.89 2 6.457C2 11 9 18 9 18Zm0-9c1.29 0 2.333-1.007 2.333-2.25C11.333 5.509 10.29 4.5 9 4.5c-1.287 0-2.332 1.008-2.332 2.25C6.667 7.994 7.712 9 8.999 9Z",
  clipRule: "evenodd"
})));
export default SvgIconWaypointFilled;